import { render, staticRenderFns } from "./btn-urgent.vue?vue&type=template&id=c8f417e4"
import script from "./btn-urgent.vue?vue&type=script&lang=js"
export * from "./btn-urgent.vue?vue&type=script&lang=js"
import style0 from "./btn-urgent.vue?vue&type=style&index=0&id=c8f417e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports